import { useTranslation } from "react-i18next";

import Tab from "@/components/containers/tabs/Tab";
import TabGroup from "@/components/containers/tabs/TabGroup";
import TabList from "@/components/containers/tabs/TabList";
import TabPanel from "@/components/containers/tabs/TabPanel";
import TabPanels from "@/components/containers/tabs/TabPanels";
import Legend from "@/components/helpers/Legend";
import { type User } from "@/types";

import { type Conversation } from "../types";
import ConversationList from "./conversations/ConversationList";
import UserList from "./conversations/UserList";

interface MessengerConversationTabsProps {
  open: boolean;
  onConversationClick: (conversation: Conversation<true, true, true>) => void;
  onUserClick: (user: User<true>) => void;
  activeConversationId?: number;
}

export default function MessengerConversationTabs({
  open,
  onConversationClick,
  onUserClick,
  activeConversationId,
}: MessengerConversationTabsProps) {
  const { t } = useTranslation("messenger.user");

  return (
    <TabGroup variant="secondary" className="flex h-full flex-col">
      <div className="mx-4 bg-white">
        <TabList>
          <Tab className="w-full">{t("All", { ns: "core.shared" })}</Tab>
          <Tab className="w-full">{t("Groups")}</Tab>
          <Tab className="w-full">{t("Contacts")}</Tab>
        </TabList>
        <Legend />
      </div>
      <TabPanels className="flex-1 overflow-hidden">
        <TabPanel className="h-full">
          <ConversationList
            open={open}
            onConversationClick={onConversationClick}
            activeConversationId={activeConversationId}
          />
        </TabPanel>
        <TabPanel className="h-full">
          <ConversationList
            open={open}
            onConversationClick={onConversationClick}
            type="group"
            activeConversationId={activeConversationId}
          />
        </TabPanel>
        <TabPanel className="h-full">
          <UserList onUserClick={onUserClick} />
        </TabPanel>
      </TabPanels>
    </TabGroup>
  );
}
